if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super(); this.form = this.querySelector('form');
      if (!this.form) return;
      const variant = this.form.querySelector('[name=id]'); if (variant) variant.disabled = false;
      this.submitButton = this.querySelector('[type="submit"]');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (this.cart && !window.skyCartExperience?.enabled) this.submitButton?.setAttribute('aria-haspopup', 'dialog');
      else this.submitButton?.removeAttribute('aria-haspopup');
    }
    async onSubmitHandler(event) {
      event.preventDefault();
      if (!this.submitButton || this.pending || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (window.skyCartQueue.needsRefresh) { location.assign(window.routes.cart_url); return; }
      if (!this.form.reportValidity()) return;
      // Snapshot the selected variant/quantity before another queued action changes the DOM.
      const body = new FormData(this.form);
      const flightSource = window.skyCartExperience?.capture(this);
      this.pending = true;
      this.handleErrorMessage(); this.submitButton.setAttribute('aria-disabled', 'true'); this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      // Immediate visual feedback; successful addition is still confirmed by Shopify.
      const pendingFlight = this.cart?.localName === 'cart-drawer' ? window.skyCartExperience?.start(flightSource) : null;
      try { await window.skyCartQueue.run(() => this.addToCart(body, flightSource, pendingFlight)); }
      finally {
        this.pending = false;
        this.submitButton.classList.remove('loading'); this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      }
    }
    async addToCart(body, flightSource, pendingFlight) {
      let added = false;
      try {
        if (this.cart) {
          body.set('sections', this.cart.getSectionsToRender().map(section => section.id).join(','));
          body.set('sections_url', location.pathname); this.cart.setActiveElement(document.activeElement);
        }
        const {response, data:result} = await window.skyCartQueue.request(window.routes.cart_add_url, {method:'POST',body,credentials:'same-origin',priority:'high',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
        if (!response.ok || result.status) { const error = new Error(result.description || result.message || window.cartStrings.error); error.shopifyError = true; throw error; }
        added = true;
        if (!this.cart || document.querySelector('cart-items') || this.cart.getSectionsToRender().some(section => !result.sections?.[section.id])) {
          location.assign(window.routes.cart_url); return false;
        }
        const modal = this.closest('quick-add-modal'); if (modal) modal.hide(true);
        const fly = window.skyCartExperience?.enabled && this.cart.localName === 'cart-drawer';
        this.cart.classList.remove('is-empty'); this.cart.renderContents(result, {open: !fly});
        if (fly) window.skyCartExperience.confirm(flightSource, result, pendingFlight);
        // Add returns a line item, not aggregate cart totals or shipping state.
        // The freshly rendered drawer already contains the authoritative cart values.
        document.dispatchEvent(new CustomEvent('sky:cart-updated', {detail:{itemsAdded:result}}));
        return true;
      } catch (error) {
        pendingFlight?.cancel();
        if (added) { location.assign(window.routes.cart_url); return false; }
        this.handleErrorMessage(window.skyCartQueue.needsRefresh ? window.skyCartUXConfig.strings.requestUncertain : error.shopifyError ? error.message : window.cartStrings.requestError || window.cartStrings.error);
        return false;
      }
    }
    handleErrorMessage(message = '') {
      let wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper) { wrapper = document.createElement('div'); wrapper.className = 'product-form__error-message-wrapper'; wrapper.setAttribute('role','alert'); const text = document.createElement('span'); text.className = 'product-form__error-message'; wrapper.append(text); this.prepend(wrapper); }
      wrapper.hidden = !message; wrapper.querySelector('.product-form__error-message').textContent = message;
      wrapper.querySelector('[data-sky-recover]')?.remove();
      if (message && window.skyCartQueue?.needsRefresh) {
        const link = document.createElement('a');
        link.dataset.skyRecover = '';
        link.href = window.routes.cart_url;
        link.textContent = window.skyCartUXConfig.strings.viewCart;
        wrapper.append(link);
      }
    }
  });
}
